module.exports = __webpack_public_path__ + "static/media/more.5f814e37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/more.svg
// module id = 139
// module chunks = 0